import React, { useEffect, useContext, useState, Fragment } from 'react';
import farmerContext from "../../../context/farmer/farmerContext";
import AddBank from './AddBank'



const WalletSettingsScreen = () => {

    const FarmerContext = useContext(farmerContext);

    const [showResults, setShowResults] = useState(true)
    const [hideUpdate, setHideUpdate] = useState(true)
    const { farmer, getBanks, getUserBank, } = FarmerContext;
    const { loading,userBank } = farmer;

    useEffect(() => {
        getBanks()
        if (userBank.length === 0) {
            const interval = setInterval(() => {
                getUserBank();
                setShowResults(false)
              }, 3000);
              return () => clearInterval(interval);
            
        }

    }, [userBank]);

    const activateForm = () => {
        setShowResults(false)
        setHideUpdate(false)
    };

    return (
        <Fragment>

            return (
            <div class="content-wrapper">
                <div class="container-fluid">
                    <h3 class="make-bold">Wallet</h3>
                    <p>Create and Update Bank Account</p>

                    <div class="dashboard-inner-view">
                        <div class="row mt-5">
                            <div class="col-lg-6">
                                <AddBank disabled={showResults} />
                            </div>
                            <div class="col-lg-4">
                            <div className="text-center mb-10 mb-lg-20">
                            <h6 className="text-muted font-weight-bold">Active Bank Account</h6>
                            </div>
                               
                                { userBank !== null ?
                                    (<div class="card p-3">
                                        <div class="card-body d-flex flex-column h-100">
                                            <div class="d-flex justify-content-between align-items-center mb-3">
                                                <p class="mb-0"><strong>Bank Name:</strong></p>
                                                <p class="mb-0"><strong>{userBank.bank_name}</strong></p>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center mb-3">
                                                <p class="mb-0">Account Number:</p>
                                                <p class="mb-0">{userBank.account_number}</p>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center mb-3">
                                                <p class="mb-0">Account Name:</p>
                                                <p class="mb-0">{userBank.account_name}</p>
                                            </div>
                                            <div class="py-1">
                                                <hr></hr>
                                            </div>
                                            <div class="mt-1">
                                            {hideUpdate && <button onClick={activateForm} className="btn btn-orange btn-block text-white">Update Bank</button>}
                                            </div>
                                        </div>
                                    </div>):(<div class="card p-3">
                                            <div class="card-body d-flex flex-column h-100">
                                                <div class="d-flex justify-content-between align-items-center mb-3">
                                                    <p class="mb-0"><strong>No bank Account Added</strong></p>
                                                </div>
                                            </div>
                                    </div>)
                                }
                            </div>
                        </div>

                        {/* loader when the data is still processing */}
                        <div className="row">
                            <div className="col-lg-12">
                                <div className={loading + " justify-content-center"}>
                                    <div className="spinner-grow text-success" role="status"
                                        style={{ width: "6rem", height: "6rem" }}>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >

    )
}

export default WalletSettingsScreen